import { PureLightTheme } from './schemes/PureLightTheme';
import { GreyGooseTheme } from './schemes/GreyGooseTheme';
import { PurpleFlowTheme } from './schemes/PurpleFlowTheme';
import { VentelTheme } from './schemes/VentelTheme_round';
import { VentelThemeDark } from './schemes/VentelThemeDark';

const themeMap = {
  PureLightTheme,
  GreyGooseTheme,
  PurpleFlowTheme,
  VentelTheme,
  VentelThemeDark
};

export function themeCreator(theme) {
  return themeMap[theme];
}
